export default __webpack_public_path__ + "static/MediaMainBannerMobile-6c2f5f2530f3ce2ce6213c889c4a80b9.webp";